module.exports = __webpack_public_path__ + "static/media/lincoln-icon-noneOption.dfb4e204.svg";